import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { autoSelectService, selectRow } from 'store/Services/actions';
import { selectSelectAllServices, selectServicesSelected, selectUnselectedRowFromSelectAll } from 'store/Services/selectors';
import Checkbox from 'Common/Components/Checkbox';
import Skeleton from 'Common/Components/Skeleton';

export const CheckColum = ({ service, showSkeleton }) => { // eslint-disable-line import/prefer-default-export
  const servicesSelected = useSelector((state) => selectServicesSelected(state));
  const dispatch = useDispatch();
  const isSelected = servicesSelected.find((serviceSelected) => serviceSelected._id === service._id);
  const selectAll = useSelector(selectSelectAllServices);
  const unselectedRowFromSelectAll = useSelector(selectUnselectedRowFromSelectAll);
  const handleClick = (e) => dispatch(selectRow(e, service));

  useEffect(() => {
    if (!showSkeleton && selectAll && !isSelected && !unselectedRowFromSelectAll) {
      dispatch(autoSelectService(service));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectAll]);

  if (showSkeleton) return <Skeleton />;
  return (
    <Checkbox theme="grey" state={ !!isSelected } onChange={ handleClick } />
  );
};
